import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col } from 'reactstrap';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

import BlastOffPreview from './landing-pages/blast-off-preview';
import MathAssessmentEmail from './landing-pages/math-assessment-email';
import MathAssessmentPhone from './landing-pages/math-assessment-phone';
import TrainLikeAnAstronaut from './landing-pages/train-like-an-astronaut';
import LearnToCode from './landing-pages/learn-to-code';
import ScrollToTop from 'components/shared/scroll-to-top';
import Landing from 'components/containers/landing';
import LoginForm from 'components/form-login';
import RegisterForm from 'components/form-register';
import ResetPassword from 'components/form-password-reset';
import OnboardForm from 'components/form-onboard';
import Educator from 'components/containers/funnel/educator';
import Parent from 'components/containers/funnel/parent';
import MarketingLanding from 'components/containers/marketing-landing';
import BenefitsPage from 'components/containers/benefits-page';
import ResetPasswordSubmit from 'components/form-password-reset/submit';
import TrialConfirmSubmit from 'components/form-onboard/submit';
import UnytedCertifiedInstructors from 'components/containers/unauthenticated/unyted-certified-instructors';
import CaseStudies from 'components/containers/case-studies';
import FAQPage from 'components/containers/faq-page';
import WhatIsSEL from 'components/containers/what-is-sel';
import AboutSelStakeholder from 'components/containers/about-sel-stakeholder';
import Checkout from 'components/containers/parents/checkout';
import TOS from './tos';
import Header from './header';
import Footer from './footer';
import OnlinePlatform from './services/online-platform';
import LearningCenterDetailsSlugWrapper from './services/learning-center-details-slug-wrapper';
import ServiceDetailsSlugWrapper from './services/service-details-slug-wrapper';
import LandingTemplate from './landing-template';
import OnboardingSchedule from './onboarding-schedule';
import Workshops from './services/workshops';
import OnlineLearningCenters from './services/online-learning-centers';
import ULCIndex from './services/learning-centers-index';
import SelEncyclopediaIndex from './sel-encyclopedia';
import SelEncyclopediaCompetency from './sel-encyclopedia/competency';
import SelEncyclopediaTargetedSkill from './sel-encyclopedia/targeted-skill';
import AboutUnyted from 'components/containers/about-unyted';
import LoadingSpinner from 'components/shared/loading-spinner';
import ErrorBoundary from 'components/shared/error-boundary';
import UnytedMethod from './unyted-method';
import style from './styles.module.scss';
import './template-styles.nomodules.scss';

const WHITE_BACKGROUND_WHITELIST = [
  '/',
  '/parents',
  '/educators',
  '/workshops',
  '/unyted-learning-centers',
  '/online-platform',
  '/case-studies',
  '/what-is-sel',
  '/sel-for/educators',
  '/sel-for/parents',
  '/sel-for/students',
  '/the-team-method',
  '/terms-of-service-privacy-policy',
  '/about-unyted',
  '/landing-example',
  '/unyted-learning-centers/all',
  '/train-like-an-astronaut',
  '/marketplace/checkout',
];

const isEncyclopediaPage = url => url.match(/sel-encyclopedia/);

const ConnectedUnauthenticated = withRouter(
  inject('spinnerStore')(
    observer(
      class Unauthenticated extends Component {
        constructor(props) {
          super(props);
          this.state = { hideRegistration: false };
        }

        toggleRegistration = e => {
          this.setState({ hideRegistration: !this.state.hideRegistration });
        };

        render() {
          const { hideRegistration } = this.state;
          const path = window.location.pathname;
          console.log('path', path);
          const whiteBackground =
            WHITE_BACKGROUND_WHITELIST.includes(path) ||
            isEncyclopediaPage(path);
          const simplifiedHeader =
            path.match(/unyted-learning-centers\/\d+/) ||
            path.match(/unyted-learning-centers\/all/) ||
            path.match(/learning-center-onboard/) ||
            path.match(/landing-example/) ||
            path.match(/math-assessment-email/) ||
            path.match(/math-assessment-phone/) ||
            path.match(/train-like-an-astronaut/) ||
            path.match(/blast-off-camp/) ||
            path.match(/services\/*/) ||
            path.match(/marketplace/);

          const landing = path === '/';

          const noFooter =
            path.match(/landing-example/) ||
            path.match(/math-assessment-email/) ||
            path.match(/math-assessment-phone/) ||
            path.match(/train-like-an-astronaut/) ||
            path.match(/services\/*/);

          return (
            <ErrorBoundary>
              <div className="unauthenticated">
                {this.props.spinnerStore.active && <LoadingSpinner />}
                <ScrollToTop />
                <Header
                  simplified={simplifiedHeader}
                  landing={landing}
                  hideRegistration={hideRegistration}
                />
                <Row
                  className={`${style.unauthenticatedContent} ${
                    whiteBackground ? style.white : ''
                  }`}
                >
                  <Switch>
                    <Route exact path="/" component={Landing} />
                    <Route
                      exact
                      path="/landing-example"
                      component={LandingTemplate}
                    />
                    <Route
                      exact
                      path="/math-assessment-email"
                      component={MathAssessmentEmail}
                    />
                    <Route
                      exact
                      path="/math-assessment-phone"
                      component={MathAssessmentPhone}
                    />
                    <Route exact path="/educators" component={Educator} />
                    <Route exact path="/parents" component={Parent} />
                    <Route
                      path="/parents-tips"
                      render={props => (
                        <MarketingLanding
                          type="parents-tips"
                          toggleRegistration={this.toggleRegistration}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/parents-info"
                      render={props => (
                        <MarketingLanding
                          type="parents-info"
                          toggleRegistration={this.toggleRegistration}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/teachers-tips"
                      render={props => (
                        <MarketingLanding
                          type="teachers-tips"
                          toggleRegistration={this.toggleRegistration}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      path="/teachers-info"
                      render={props => (
                        <MarketingLanding
                          type="teachers-info"
                          toggleRegistration={this.toggleRegistration}
                          {...props}
                        />
                      )}
                    />
                    <Route path="/case-studies" component={CaseStudies} />
                    <Route
                      path="/unyted-certified-educators"
                      component={UnytedCertifiedInstructors}
                    />
                    <Route
                      path="/train-like-an-astronaut"
                      component={TrainLikeAnAstronaut}
                    />
                    <Route path="/blast-off-camp" component={BlastOffPreview} />
                    <Route path="/learn-to-code" component={LearnToCode} />

                    <Route path="/faq" component={FAQPage} />
                    <Route path="/what-is-sel" component={WhatIsSEL} />
                    <Route
                      path="/sel-for/:type"
                      component={AboutSelStakeholder}
                    />
                    <Route path="/online-platform" component={OnlinePlatform} />
                    <Route path="/workshops" component={Workshops} />
                    <Route path="/the-team-method" component={UnytedMethod} />
                    <Route path="/about-unyted" component={AboutUnyted} />
                    <Route
                      path="/marketplace/checkout"
                      render={renderProps => <Checkout {...renderProps} />}
                    />
                    <Redirect
                      push
                      from="/online-learning-centers"
                      to="/marketplace"
                    />
                    <Redirect
                      push
                      from="/unyted-learning-centers/all"
                      to="/marketplace/all"
                    />
                    <Route
                      path="/marketplace/all/:type?"
                      component={ULCIndex}
                      exact
                    />
                    <Route
                      path="/unyted-learning-centers/:ulcSlugOrId"
                      component={LearningCenterDetailsSlugWrapper}
                    />
                    <Route
                      path="/services/:slugOrId/:selectedLearningCenterId?"
                      component={ServiceDetailsSlugWrapper}
                    />
                    <Route
                      path="/learning-center-onboard"
                      component={OnboardingSchedule}
                    />
                    <Redirect
                      push
                      path="/unyted-learning-centers"
                      to="/marketplace"
                    />
                    <Route
                      path="/marketplace"
                      component={OnlineLearningCenters}
                    />
                    <Route
                      path="/sel-encyclopedia/competencies/:competency/:targetedSkill"
                      component={SelEncyclopediaTargetedSkill}
                    />
                    <Route
                      path="/sel-encyclopedia/competencies/:competency"
                      component={SelEncyclopediaCompetency}
                    />
                    <Route
                      path="/sel-encyclopedia"
                      component={SelEncyclopediaIndex}
                    />
                    <Route
                      path="/terms-of-service-privacy-policy"
                      component={TOS}
                    />

                    <Col sm={12}>
                      <Switch>
                        <Route
                          path="/benefits/:type"
                          render={props => (
                            <BenefitsPage
                              {...props}
                              toggleBackgroundColor={this.toggleBackgroundColor}
                              toggleRegistration={this.toggleRegistration}
                            />
                          )}
                        />
                        <Route path="/login" component={LoginForm} />
                        <Route path="/signup" component={RegisterForm} />
                        <Route path="/password" component={ResetPassword} />
                        <Route
                          path="/reset_password/:token"
                          component={ResetPasswordSubmit}
                        />
                        <Route
                          path="/users/:id/confirm/:token"
                          component={TrialConfirmSubmit}
                        />
                        <Route
                          path="/community-onboard"
                          component={OnboardForm}
                        />
                        <Route
                          path="*"
                          render={() => <Redirect to="/login" />}
                        />
                      </Switch>
                    </Col>
                  </Switch>
                </Row>
                {!noFooter && <Footer />}
              </div>
            </ErrorBoundary>
          );
        }
      },
    ),
  ),
);

export default ConnectedUnauthenticated;
